import lwAPI from "@/common/api.service";

const state = {
  publicStudyLists: [],
  studyLists: [],
  studyList: {},
  items: [],
  item: {},
  examples: [],
};

const getters = {
  publicStudyLists: (state) => state.publicStudyLists,
  userStudyLists: (state) => state.studyLists,
  studyList: (state) => state.studyList,
  items: (state) => state.items,
  item: (state) => state.item,
  examples: (state) => state.examples,
};

const actions = {
  // Study Lists
  async fetchPublicStudyLists({ commit }) {
    const response = await lwAPI.get("/studylists/");

    commit("setPublicStudyLists", response.data);
  },
  async fetchUserStudyLists({ commit }) {
    const response = await lwAPI.get("/user/studylists/");

    commit("setStudyLists", response.data);
  },
  async fetchStudyList({ commit }, id) {
    const response = await lwAPI.get(`/studylists/${id}/`);

    commit("setStudyList", response.data);
  },
  async addStudyList({ commit }, payload) {
    const response = await lwAPI.post("/user/studylists/", {
      name: payload.title,
      term_language: payload.termLanguage,
      meaning_language: payload.meaningLanguage,
      description: payload.description,
      private: payload.private,
    });

    commit("newStudyList", response.data);

    return response.data;
  },
  async updateStudyList({ commit, state }, payload) {
    await lwAPI.put(`/studylists/${payload.id}/`, {
      name: payload.title,
      term_language: payload.termLanguage,
      meaning_language: payload.meaningLanguage,
      description: payload.description,
      private: payload.private,
    });
    commit("setStudyList", {
      ...state.studyList,
      name: payload.title,
      term_language: payload.termLanguage,
      meaning_language: payload.meaningLanguage,
      description: payload.description,
      private: payload.private,
    });
  },
  async deleteStudyList({ commit }, id) {
    await lwAPI.delete(`/studylists/${id}/`);

    commit("removeStudyList", id);
  },
  // Items
  async fetchItems({ commit }, studyListId) {
    const response = await lwAPI.get(`/studylists/${studyListId}/items/`);

    commit("setItems", response.data);
  },
  async addItem({ commit }, { studyListId, item }) {
    const response = await lwAPI.post(`/studylists/${studyListId}/items/`, {
      term: item.term,
      meaning: item.meaning,
    });
    commit("newItem", response.data);
  },
  async fetchItem({ commit }, id) {
    const response = await lwAPI.get(`/items/${id}/`);

    commit("setItem", response.data);
    commit("setExamples", response.data.examples);
  },
  async updateItem({ commit, state }, payload) {
    await lwAPI.put(`/items/${payload.id}/`, {
      term: payload.term,
      meaning: payload.meaning,
    });
    commit("setItem", {
      ...state.item,
      term: payload.term,
      meaning: payload.meaning,
    });
  },
  async deleteItem({ commit }, id) {
    await lwAPI.delete(`/items/${id}/`);

    commit("removeItem", id);
  },
  // Import Terms
  async importTerms({ commit }, { studyListId, terms }) {
    console.log(terms);
    const response = await lwAPI.post(`/studylists/${studyListId}/import/`, {
      terms: terms,
    });
    commit("setItems", response.data);
  },
  // Examples
  async addExample({ commit }, { itemId, example }) {
    const response = await lwAPI.post(`/items/${itemId}/examples/`, {
      content: example.content,
      description: example.description,
    });
    commit("newExample", response.data);
  },
  async deleteExample({ commit }, { itemId, exampleId }) {
    await lwAPI.delete(`/items/${itemId}/examples/${exampleId}/`);

    commit("removeExample", exampleId);
  },
};

const mutations = {
  setPublicStudyLists: (state, studyLists) =>
    (state.publicStudyLists = studyLists),
  setStudyLists: (state, studyLists) => (state.studyLists = studyLists),
  setStudyList: (state, studyList) => (state.studyList = studyList),
  setItems: (state, items) => (state.items = items),
  newStudyList: (state, studyList) => state.studyLists.unshift(studyList),
  removeStudyList: (state, id) =>
    (state.studyLists = state.studyLists.filter((sl) => sl.id !== id)),
  newItem: (state, item) => state.items.unshift(item),
  setItem: (state, item) => (state.item = item),
  removeItem: (state, id) =>
    (state.items = state.items.filter((item) => item.id !== id)),
  setExamples: (state, examples) => (state.examples = examples),
  newExample: (state, example) => state.examples.push(example),
  removeExample: (state, id) =>
    (state.examples = state.examples.filter((example) => example.id !== id)),
};

export default {
  state,
  getters,
  actions,
  mutations,
};
